import React, { useState, useEffect } from 'react';
import {Button, message, Modal} from 'antd';
import './style.css';

const newsItems = [
    {
        date: '悬浮按钮',
        title: '清爽界面 一触即发',
        image: require('../../assets/images/float_window.jpg')
    },
    {
        date: '智能规划',
        title: '一键跳转高德/百度/腾讯地图',
        image: require('../../assets/images/auto-drive.jpg')
    },
    {
        date: '个性化设置',
        title: '高速/拥堵/时间 统统都有',
        image: require('../../assets/images/smart-light.jpg')
    }
];

const aboutContent = {
    title: "关于我们",
    description: "王导导是一款网约车司机助手APP，致力于为司机提供便捷的导航体验。主要功能是自动识别页面中的地址，一键跳转地图应用进行路线规划，方便用户操作。",
    features: [
        "支持多平台导航：高德、百度、腾讯地图无缝对接",
        "智能路线规划：考虑实时路况，为您推荐最优路线",
        "个性化设置：根据个人偏好自定义导航参数",
        "便捷操作：悬浮窗设计，随时随地一键导航"
    ]
};

const scrollImages = [
    {
        src: require('../../assets/images/Screenshot_20241120_121902.jpg'),
        alt: '功能展示1'
    },
    {
        src: require('../../assets/images/Screenshot_20241120_121917.jpg'),
        alt: '功能展示2'
    },
    {
        src: require('../../assets/images/Screenshot_20241120_121930.jpg'),
        alt: '功能展示3'
    },
    {
        src: require('../../assets/images/Screenshot_20241121_133042.jpg'),
        alt: '功能展示4'
    },
    {
        src: require('../../assets/images/smart-light.jpg'),
        alt: '功能展示5'
    },
];

const isWeixinBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1;
};

const Hero: React.FC = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        setIsModalVisible(true);
    }, []);

    const handleModalClose = () => {
        setIsModalVisible(false);
    };

    const handleDownload = () => {
        const ua = navigator.userAgent.toLowerCase();
        const isWeixin = ua.indexOf('micromessenger') !== -1;
        const isAndroid = ua.indexOf('android') !== -1;
        const isIos = (ua.indexOf('iphone') !== -1) || (ua.indexOf('ipad') !== -1);

        if (isWeixin) {
            Modal.info({
                title: '温馨提示',
                content: (
                    <div style={{ textAlign: 'center', padding: '20px 0' }}>
                        <div style={{
                            width: '100%',
                            marginBottom: '20px'
                        }}>
                            <img
                                src={isAndroid ? require('../../assets/images/android.jpg') : require('../../assets/images/ios.jpg')}
                                style={{ width: '100%', maxWidth: '320px' }}
                                alt="guide"
                            />
                        </div>
                        <div style={{
                            width: '100%',
                            marginBottom: '20px'
                        }}>
                            <img
                                src={isAndroid ? require('../../assets/images/androidydt.jpg') : require('../../assets/images/iosydt.jpg')}
                                style={{ width: '100%', maxWidth: '320px' }}
                                alt="guide"
                            />
                        </div>
                        <p style={{ color: '#174ded', fontSize: '18px', fontWeight: 'bold' }}>
                            暂不支持在微信中下载
                        </p>
                        <p style={{ color: '#174ded', fontSize: '18px', fontWeight: 'bold' }}>
                            请在浏览器打开访问
                        </p>
                    </div>
                ),
                okText: '我知道了',
                centered: true,
                width: 350,
                maskClosable: false,
            });
        } else {
            window.location.href = 'https://download.wangdaodao.cn/wdd_1006.apk';
        }
    };

    return (
        <div className="hero">
            <Modal
                open={isModalVisible}
                onCancel={handleModalClose}
                footer={[
                    <Button
                        key="ok"
                        type="primary"
                        onClick={handleModalClose}
                        style={{ width: '100%' }}
                    >
                        我知道了
                    </Button>
                ]}
                width={320}
                centered
                closable={false}
                maskClosable={false}
            >
                <div style={{
                    textAlign: 'center',
                    padding: '20px 0',
                    fontSize: '16px',
                    lineHeight: '1.5'
                }}>
                    司机推荐另一个司机新用户注册，该司机免费试用2个月!
                </div>
            </Modal>
            <div className="hero-content">
                <h1>MORE THAN A JOURNEY</h1>
                <h2>王导导 您的出行规划专家</h2>
                <Button
                    type="primary"
                    size="large"
                    onClick={handleDownload}
                >
                    立即下载
                </Button>


                <div className="about-section">
                    <h2>{aboutContent.title}</h2>
                    <p className="about-description">{aboutContent.description}</p>
                    <div className="news-section">
                        {newsItems.map((item, index) => (
                            <div key={index} className="news-item">
                                <div className="news-image">
                                    <img src={item.image} alt={item.title}/>
                                </div>
                                <span className="news-date">{item.date}</span>
                                <h3 className="news-title">{item.title}</h3>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="about-section">
                    <h2>APP运行效果图</h2>
                    <div className="scroll-section">
                        <div className="scroll-container">
                            {[...scrollImages, ...scrollImages].map((image, index) => (
                                <div key={index} className="scroll-item">
                                    <img src={image.src} alt={image.alt}/>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
                <div className="icp-footer">
                    <span>@2024 王导导</span>
                    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
                        京ICP备2023025405号
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Hero;
